export { Animated } from './animated.component';
